export class Header {
    langCode = "";
    packageKey = 0;
    propertyKey = 0;
    reportAddress = "";
    reportTitle = "";
    reportType = "";
}

export class Quotes {
    breakableCoverage = "";
    dwellingCoverage = "";
    dwellingDeductibleAmount = "";
    dwellingDeductiblePercent = "";
    estimateDate = "";
    estimateStart = "";
    lossAssessmentCoverage = "";
    lossAssessmentDeductibleAmount = "";
    lossAssessmentDeductiblePercent = "";
    lossOfUseCoverage = "";
    personalPropertyCoverage = "";
    personalPropertyDeductibleAmount = "";
    personalPropertyDeductiblePercent = "";
    policyType = "";
    premiumAnnual = "";
    premiumMonthly = "";
    yearBuilt = "0";
    zipCode = "";
    hazardDiscount = "21%";
    hazardStatus = " ";
    hazardHrdIndicator = '';
    buildingCodeCoverage = "";
    bracingSystem = "";
    roofType = "";
    stories = "";
    masonryCoverage = "";
    foundationType = "";
    frame = "";
}

export class Label {
    title = "";
    minimum = "";
    disclaimer = "";
    policyDetails = "";
    policyType = "";
    zipCode = "";
    estimateDate = "";
    estimateStart = "";
    personalProperty = "";
    personalPropertyCoverage = "";
    personalPropertyDeductibleAmount = "";
    personalPropertyDeductiblePercent = "";
    breakableCoverage = "";
    lossOfUse = "";
    lossOfUseCoverage = "";
    premium = "";
    premiumMonthly = "";
    premiumAnnual = "";
    dwelling = "";
    dwellingCoverage = "";
    dwellingDeductibleAmount = "";
    dwellingDeductiblePercent = "";
    lossAssessment = "";
    lossAssessmentCoverage = "";
    lossAssessmentDeductibleAmount = "";
    lossAssessmentDeductiblePercent = "";
    yearBuilt = "";
    hazardDiscount = "";
    hazardStatus = " ";
    hazardHrdIndicator = "";
    buildingCode = "";
    buildingCodeCoverage = "";
    bracingSystem = "";
    stories = "";
    masonryCoverage = "";
    foundationType = "";
    frame = "";
    roofType = "";
}

export class DownloadFilePostModel {
    header: Header;
    label: Label;
    quotes: Quotes[];
}
